import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch, useStore } from 'react-redux';

const useAddressBookContacts = load => {
  const store = useStore();
  const byType = useSelector(store.select.addressBookContacts.byType);
  const isLoading = useSelector(state => state.loading.effects.addressBookContacts.load);

  const dispatch = useDispatch();

  useEffect(() => {
    if (load) dispatch.addressBookContacts.load();
  }, [dispatch, load]);

  const findOneAddressBookContactByUserId = useCallback(
    userId => {
      const contacts = byType.all || [];
      return contacts.find(c => c.user.id === userId);
    },
    [byType.all],
  );

  const findOneAddressBookContactByContactId = useCallback(
    contactId => {
      const contacts = byType.all || [];
      return contacts.find(c => c.id === contactId);
    },
    [byType.all],
  );

  const findOneAddressBookContactByPvsId = useCallback(
    pvsId => {
      const contacts = byType.allPatients || [];
      return contacts.find(c => c.pvsId === pvsId);
    },
    [byType.allPatients],
  );

  return {
    ...byType,
    isLoading,
    load: dispatch.addressBookContacts.load,
    findOneAddressBookContactByUserId,
    findOneAddressBookContactByContactId,
    findOneAddressBookContactByPvsId,
  };
};

export default useAddressBookContacts;
